import React from "react";

// MUI Imports
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const MemberEventsHeader = () => {
  const headCells = [
    { id: "Date / Time", numeric: false, label: "Date / Time" },
    { id: "Category", numeric: false, label: "Category" },
    { id: "Action", numeric: false, label: "Action" },
    { id: "IP Address", numeric: false, label: "IP Address" },
    { id: "User Agent", numeric: false, label: "User Agent" },
    { id: "Metadata", numeric: false, label: "Metadata" },
  ];

  return (
    <TableHead>
      <TableRow className="header">
        {headCells.map(({id, label}) => (
          <TableCell
            key={id}
            className="headerText"
            align="center"
            padding="normal"
          >
            {label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default MemberEventsHeader;
